import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './employSetPassword.module.css';
import commonStyles from "components/commonStyle/commonStyle.module.css";
import { IoCloseOutline } from "react-icons/io5";
import { logout } from 'services/userLogin/logout';
import { checkSession } from 'services/userLogin/check-session';
import ErrorFailed from 'components/errorFailed/errorFailed';
import { setEmployPassword } from 'services/userLogin/set-employ-password';

export default function EmploySetPassword() {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [rePassword, setRePassword] = useState('');
    const [error, setError] = useState<string | null>(null);

    const verifySession = async () => {
        try {
            const sessionData = await checkSession();
            if (sessionData.session_active) {
                const { id, is_employee, email, is_password_completed, is_statistic } = sessionData.user_data;
                if (is_employee) {
                    if (!is_password_completed) {
                        setEmail(email);
                    } else {
                        if (is_statistic) {
                            navigate('/reservierungsportal/StatisticPage', { replace: true });

                        } else {
                            navigate('/reservierungsportal/EmployHomePage', { replace: true });
                        }
                    }

                } else {
                    navigate('/reservierungsportal', { replace: true });
                }
            } else {
                navigate('/reservierungsportal', { replace: true });
            }
        } catch (error) {
            console.error("Error during session check:", error);
        }
    };

    const handlePasswordChange = async () => {
        if (password !== rePassword) {
            setError("Die Passwörter stimmen nicht überein.");
            return;
        }
        const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*-_+?&])[A-Za-z\d@$!%*-_+?&]{8,}$/;
        if (!passwordRegex.test(password)) {
            setError(
                "Das Passwort muss mindestens 8 Zeichen lang sein, einen Großbuchstaben, einen Kleinbuchstaben, eine Zahl und ein Sonderzeichen enthalten."
            );
            return;
        }

        try {
            const sessionData = await checkSession();

            const userId = sessionData.user_data.user_id;
            const email = sessionData.user_data.email;
            const result = await setEmployPassword(userId, password, email);
            if (result.success) {
                setError(null);
                if (sessionData.session_active) {
                    const { id, is_employee, email, is_statistic } = sessionData.user_data;
                    if (is_employee) {
                        if (is_statistic) {
                            navigate('/reservierungsportal/StatisticPage');
                        } else {
                            navigate('/reservierungsportal/EmployHomePage');
                        }
                    }
                }
            }else{ setError(result.message) }
        } catch (error) {
            setError("Fehler beim Setzen des Passworts. Bitte versuchen Sie es erneut. " );
        }
    };

    useEffect(() => {
        verifySession();
    }, []);

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <div>
                    <a className={styles.closeButton} onClick={logout} href='/reservierungsportal'>
                        <IoCloseOutline />
                    </a>
                    <h2>Passwort aktualisieren</h2>
                    <p>
                        Um Deine Registrierung erfolgreich abzuschließen benötigen wir noch neues Passwort.
                    </p>
                </div>
            </div>

            <div className={styles.form}>
                {error && <ErrorFailed error={error} />}

                <div className={commonStyles.formGroup}>
                    <label htmlFor="email">E-Mail</label>
                    <input
                        type="email"
                        id="email"
                        name="email"
                        value={email}
                        readOnly={true}
                    />
                </div>
                <div className={commonStyles.formGroup}>
                    <label htmlFor="password">Passwort</label>
                    <input
                        type="password"
                        id="password"
                        name="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />
                </div>
                <div className={commonStyles.formGroup}>
                    <label htmlFor="repassword">Passwort wiederholen</label>
                    <input
                        type="password"
                        id="repassword"
                        name="repassword"
                        value={rePassword}
                        onChange={(e) => setRePassword(e.target.value)}
                        required
                    />
                </div>
                <div className={styles.actionButtons}>
                    <button
                        className={`${commonStyles.commonButton} ${commonStyles.backButton}`}
                        onClick={() => {
                            logout(); 
                            window.history.back(); 
                        }}
                    >
                        abbrechen
                    </button>

                    <button
                        className={`${commonStyles.commonButton} ${commonStyles.submitButton}`}
                        onClick={handlePasswordChange}
                    >
                        Speichern
                    </button>
                </div>
            </div>
        </div>
    );
}
